export enum HeaderHeight {
  common = 64,
  menuTopMailRuHeight = 62,
  headerMailRuHeight = 56,
  allHeadersMailRuHeight = 84,
}
